import { render, staticRenderFns } from "./CreateProjectPrinciple.vue?vue&type=template&id=3f3ea50c&scoped=true&"
import script from "./CreateProjectPrinciple.vue?vue&type=script&lang=js&"
export * from "./CreateProjectPrinciple.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectPrinciple.vue?vue&type=style&index=0&id=3f3ea50c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ea50c",
  null
  
)

export default component.exports